import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { FunctionComponent, useEffect, useState } from "react";
import { stripe } from "src/utils";
import SubscriberCheckoutForm from "./SubscriptionCheckoutForm";

interface ISubscriptionPaymentProps {
  customerId: string;
  priceId: string;
  planName: string;
  billingCycle: string; // e.g., "Monthly"
  firstPaymentAmount: number; // in cents
  included: string[];
  onSubscriptionComplete: () => void;
}

const SubscriptionPayment: FunctionComponent<ISubscriptionPaymentProps> = ({
  customerId,
  priceId,
  planName,
  billingCycle,
  firstPaymentAmount,
  included,
  onSubscriptionComplete,
}) => {
  const key = process.env.REACT_APP_STRIPE_ACCESS_KEY || "";
  const stripePromise = loadStripe(key);

  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchClientSecret = async () => {
      setLoading(true);
      try {
        const result = await stripe.payments.createSetupIntent(customerId);
        setClientSecret(result.clientSecret);
      } catch (err: any) {
        setError(err.message || "Failed to create payment setup");
      } finally {
        setLoading(false);
      }
    };

    fetchClientSecret();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-400">{error}</p>;

  return (
    <div className="flex justify-around">
      {clientSecret ? (
        <Elements
          options={{
            clientSecret,
            appearance: { theme: "stripe" },
            loader: "auto",
          }}
          stripe={stripePromise}
        >
          <SubscriberCheckoutForm
            customerId={customerId}
            priceId={priceId}
            planName={planName}
            billingCycle={billingCycle}
            firstPaymentAmount={firstPaymentAmount}
            included={included}
            onSubscriptionSuccess={onSubscriptionComplete}
          />
        </Elements>
      ) : (
        <p>Loading Stripe...</p>
      )}
    </div>
  );
};

export default SubscriptionPayment;
